import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "color-select__wrapper" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "color-select__image-overlay" }, null, -1)

import { inject, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';

  import { toLitiumMediaUrlKey } from '@distancify/drapejs-litium/lib/keys';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ColorSelect',
  props: {
    colors: {
      type: Array,
      required: true,
    },
  alt: {
    type: String,
    required: true,
  },
  },
  setup(__props) {

const props = __props

  const preserveScrollPosition = inject('preserveScrollPosition');
  const toLitiumMediaUrl = inject(toLitiumMediaUrlKey, () => '');

  

  const colorSelectEl = ref<HTMLDivElement | null>(null);
  const scrollbarEl = ref<HTMLDivElement | null>(null);

  const displayCustomScrollbar = ref(false);

  function getImageUrl(color) {
    return toLitiumMediaUrl(color.imageId, { maxWidth: 120 });
  }

  function updateCustomScrollbar() {
    if (!colorSelectEl.value || !scrollbarEl.value) return;

    const { scrollLeft, scrollWidth, clientWidth } = colorSelectEl.value;

    if (scrollWidth <= clientWidth) {
      displayCustomScrollbar.value = false;
      return;
    }
    displayCustomScrollbar.value = true;

    const scrollbarWidth = (clientWidth / scrollWidth) * clientWidth;
    const scrollbarLeft = (scrollLeft / scrollWidth) * clientWidth;
    scrollbarEl.value.style.width = `${scrollbarWidth}px`;
    scrollbarEl.value.style.transform = `translateX(${scrollbarLeft}px)`;
  }

  function setupListeners() {
    if (colorSelectEl.value) {
      updateCustomScrollbar();
      colorSelectEl.value.addEventListener('scroll', updateCustomScrollbar);
      window.addEventListener('resize', updateCustomScrollbar);
    }
  }

  onMounted(() => {
    watch(
      () => props.colors.length,
      () => {
        nextTick(() => {
          setupListeners();
        });
      },
      { immediate: true }
    );
  });

  onBeforeUnmount(() => {
    colorSelectEl.value?.removeEventListener('scroll', updateCustomScrollbar);
    window.removeEventListener('resize', updateCustomScrollbar);
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.colors.length > 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "color-select",
          ref_key: "colorSelectEl",
          ref: colorSelectEl
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((props.colors as any[]), (color) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(color.isCurrent ? 'div' : 'router-link'), {
              class: _normalizeClass(["color-select__link", { 'color-select__image--current': color.isCurrent }]),
              onClick: _unref(preserveScrollPosition),
              to: color.url,
              key: color.imageId,
              "replace-history": true
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  class: "color-select__image",
                  draggable: "true",
                  src: getImageUrl(color),
                  alt: __props.alt
                }, null, 8, _hoisted_2),
                _hoisted_3
              ]),
              _: 2
            }, 1032, ["class", "onClick", "to"]))
          }), 128)),
          _createElementVNode("div", {
            class: _normalizeClass(["color-select__track", { 'color-select__track--hidden': !displayCustomScrollbar.value }])
          }, [
            _createElementVNode("div", {
              class: "color-select__scrollbar",
              ref_key: "scrollbarEl",
              ref: scrollbarEl
            }, null, 512)
          ], 2)
        ], 512))
      : _createCommentVNode("", true)
  ]))
}
}

})